export const HEALTH_CHECK_INTERVAL = 60000;
export const MOBILE_WIDTH = 768;
export const TOKEN_EXPIRED_DATE_THRESHOLD_IN_MINUTES = 15;
export const NSEWL = "North South East West Line";